import React, { type ReactNode } from 'react'
import { FLAGS } from '../config'
import { useFlagsContext } from './RootstechFlagsProvider'
import { PlaylistsProvider, usePlaylistsContext } from './PlaylistsProvider'
import { PlaylistsGlobalProvider, usePlaylistsGlobalContext } from './PlaylistsGlobalProvider'

type PlaylistContainerProvider = ({ children }: { children: ReactNode }) => JSX.Element

/** An adapter hook to help transition from the old to new playlist context */
export const usePlaylistContainerContext = (): unknown => {
  const { [FLAGS.NEW_PLAYLIST_STATE]: newPlaylistFlag } = useFlagsContext()
  const globalPlaylistState = usePlaylistsGlobalContext()
  const playlistState = usePlaylistsContext()

  if (newPlaylistFlag.isOn) {
    return globalPlaylistState
  }

  return playlistState
}

/** An adapter provider to help ease the transition to the new playlist */
export const PlaylistContainerProvider: PlaylistContainerProvider = ({ children }) => {
  const { [FLAGS.NEW_PLAYLIST_STATE]: newPlaylistFlag } = useFlagsContext()

  if (newPlaylistFlag.isOn) {
    return <PlaylistsGlobalProvider>{children}</PlaylistsGlobalProvider>
  }

  return <PlaylistsProvider>{children}</PlaylistsProvider>
}
